<template>
  <span>
    <a-tag class="is_tag" :color="instance.list[scope.scope.status].color">
       {{scope.scope.statusStr}}
    </a-tag>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  methods: {
    actionCb(cb, row) {
      this.$emit('actionClick', { cb, row })
    }
  }
}
</script>
<style lang="scss" scoped>
// .is_tag{
//   cursor: pointer;
// }
</style>